import { ComponentProps } from 'react';
import KitDynamicTrackPage from './components/DynamicTrackPage';
import { PageContext } from './hooks/PageContext/usePageContext';

export enum Devices {
  MOBILE = 'Mobile',
  DESKTOP = 'Desktop',
}

export interface PageProps extends PageContext {
  title?: string;
  userAgentDevice: Devices;
  renderHeader?: boolean;
  growthbookDevModeEnabled?: boolean;
  titanAnalyticsOptions?: ComponentProps<
    typeof KitDynamicTrackPage
  >['titanAnalyticsOptions'];
  claimPortalUrl?: string;
}

export interface ParsedParams extends PageContext {
  renderHeader?: boolean;
  growthbookDevModeEnabled: boolean;
}

export enum ExperienceHostEnum {
  NARVAR = 'NARVAR',
  EMBED = 'EMBED',
}

export enum Product {
  narvarjs = 'narvarjs',
  narvarjsBuild = 'narvarjs_build',
  narvarjsTranslations = 'narvarjs_translations',
}

export enum NoflakeTag {
  TRACK_FE = 'noflake.track_fe',
  COMPONENT_PLATFORM = 'noflake.component_platform',
  NARVAR_JS = 'noflake.narvar_js',
  BAD = 'BAD',
  RETURNS = 'noflake.returns',
  HIPAA_RETURNS = 'noflake.hipaa_returns',
  SHOPIFY_RETURNS = 'noflake.shopify_returns',
  GEN_AI_RESPONSE_EVENTS = 'noflake.gen_ai_response_events',
  ASSIST_FE = 'noflake.assist_fe',
}

export {};
